import {Component, EventEmitter, OnInit, Output} from '@angular/core';
import {AuthtokenResponse} from "../../../../model/response/auth/authtoken-response.model";
import {AuthenticationService} from "../../../../../service/authentication-service";
import {UserRoleEnum} from "../../../../enums/user-role.enum";


@Component({
    selector: 'app-admin-sidebar',
    templateUrl: './admin-sidebar.component.html',
    standalone: false
})
export class AdminSidebarComponent implements OnInit {

  user: AuthtokenResponse
  isAdmin = false
  isModerator = false
  isMaster = false
  isNormal = false

  isPrivileged = false

  @Output('navigationClicked') navigationClickedEmitter = new EventEmitter<void>()

  constructor(private authService: AuthenticationService) {
  }

  ngOnInit(): void {
    this.user = this.authService._user.getValue()

    if (this.user) {
      this.isAdmin = this.user.role === UserRoleEnum.ADMIN
      this.isModerator = this.user.role === UserRoleEnum.MODERATOR
      this.isMaster = this.user.role === UserRoleEnum.MASTER
      this.isNormal = this.user.role === UserRoleEnum.NORMAL

      this.isPrivileged = this.isAdmin || this.isModerator || this.isMaster
    }
  }

  onNavigationClicked() {
    this.navigationClickedEmitter.emit()
  }

}
